module.exports = __webpack_public_path__ + "static/media/transgender-alt.d82c58c4.svg";